export const NAVER_MAP_CLIENT_ID = '8tchgu55fw';
export const NAVER_MAP_CLIENT_KEY = 'ynTflPnwB2jcYHpoYQIhxRixN0hCBQ8C8sX9729D';